export default (state = {}, action) => {
  switch (action.type) {
    case 'PANEL_RECOMMENDEDS_GET':
      return { ...state, recommendeds: action.recommendeds };
    default:
      return state;
  }
};
